import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../../environment';
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IItem, IItemList, IItemListResponse, IItemResponse } from './item.model';
import { SHOW_TOAST } from '../../../login/login.service';

export type EntityArrayResponseType = HttpResponse<IItemListResponse>;
export type EntityResponseType = HttpResponse<IItem>;
export type EntityItemResponse = HttpResponse<IItemResponse>;

export interface ItemMassiveLoadError {
  rowNumber: number;
  identifier?: string;
  field?: string;
  message: string;
}

export interface ItemMassiveLoadResponse {
  updatedRows: number;
  totalErrors: number;
  errors: ItemMassiveLoadError[];
  technicalError?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ItemService {
  private apiItem = `${environment.wsApiBaseUrl}/api/item`
  protected readonly http = inject(HttpClient);

  findByParams(params: any): Observable<EntityArrayResponseType> {
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value === null || value === undefined || value === "") delete params[key];
    });
    return this.http.get<IItemListResponse>(`${this.apiItem}/get-all`, { observe: 'response', params });
  }

  activate(activate: boolean, id: number): Observable<EntityResponseType> {
    return this.http.put<IItem>(`${this.apiItem}/activate/${id}`, { active: activate }, { observe: 'response' })
  }

  create_related_items(itemId: string, relatedItemIds: string[]): Observable<any> {
    const params = {
      itemId: itemId,
      relatedItemIds: relatedItemIds.join(',')
    };
    return this.http.post(`${this.apiItem}/related-items`, null, { observe: 'response', params });
  }

  delete_related_items(itemId: string, relatedItemIds: string[]): Observable<any> {
    const params = {
      itemId: itemId,
      relatedItemIds: relatedItemIds.join(',')
    };
    return this.http.delete(`${this.apiItem}/related-items`, { observe: 'response', params });
  }

  find_by_ids(ids: string[], customerAN?: number | string | null): Observable<EntityArrayResponseType> {
    const params: Record<string, string> = { ids: ids.join(',') };
    if (customerAN !== undefined && customerAN !== null) {
      params['customerAN'] = String(customerAN);
    }
    return this.http.get<IItemListResponse>(`${this.apiItem}/get-all`, { observe: 'response', params });
  }

  findById(id: number): Observable<EntityItemResponse> {
    return this.http.get<IItemResponse>(`${this.apiItem}/get-one/${id}`, { observe: 'response', params: { completeSearch: false } });
  }

  update(payload: any, id: number): Observable<HttpResponse<any>> {
    return this.http.put(`${this.apiItem}/update-one/${id}`, payload, { observe: 'response' });
  }

  massiveLoad(file: File): Observable<HttpResponse<ItemMassiveLoadResponse>> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<ItemMassiveLoadResponse>(
      `${this.apiItem}/massive-load`,
      formData,
      {
        observe: 'response',
        context: new HttpContext().set(SHOW_TOAST, false)
      }
    );
  }

  getPriceJDE(itemIds: string[], customerAN: string | number): Observable<any> {
    const params = {
      itemId: itemIds.join(','),
      customerAN: String(customerAN)
    };
    return this.http.get<any>(`${this.apiItem}/get-price-jde`, { params });
  }

  getDiscounts(customerId: number): Observable<any> {
    return this.http.get<any>(`${this.apiItem}/get-discounts`, { params: { customerId } });
  }
}
